import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  TranslationProvider,
} from '@resy/ui-kitchen';

import CheckmarkSuccess from '../../../../../ui-kitchen/src/svg/icons/ic_checkmark-success_20x20.svg';
import LoadingSpinner from '../../../../../ui-kitchen/src/svg/icons/processing-spinner.svg';
import Question from '../../../images/icons/question.svg';
import { postUserProfileRatingOptout } from '../../../../../ui-kitchen/src/api/api';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import './OptOut.scss';

const NotFoundIcon = <Question aria-hidden="true" />;
const SuccessIcon = <CheckmarkSuccess className="Icon--checkmark" aria-hidden="true" />;
const LoadingIcon = <LoadingSpinner className="Icon--loading" aria-hidden="true" />;

const OptOut = ({ $location }) => {
  const [notFound, setNotFound] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  React.useEffect(() => {
    const optOutUser = async () => {
      const queryParams = $location.search();
      const { token } = queryParams;
      try {
        await postUserProfileRatingOptout({ token });
        setSuccess(true);
      } catch (error) {
        Logger.error('[OptOut] error: ', error);
        setNotFound(true);
      }
    };

    optOutUser();
  }, [$location]);

  const renderNotFound = () => (
    <div className="OptOut">
      {NotFoundIcon}
      <TranslationProvider translationKey="not_found">
        <h1>Not Found.</h1>
      </TranslationProvider>

      <div className="OptOut__body">
        <TranslationProvider translationKey="link_may_have_expired">
          <div className="OptOut__upper-text">
            The link may have expired. Please
            {' '}
            <a href="mailto:help@resy.com">email us</a>
            {' '}
            if you have questions.
          </div>
        </TranslationProvider>
        <hr />

        <TranslationProvider translationKey="go_to_resy">
          <Link href="/">
            Go to Resy.com ›
          </Link>
        </TranslationProvider>
      </div>
    </div>
  );

  const renderSuccess = () => (
    <div className="OptOut">
      {SuccessIcon}
      <TranslationProvider translationKey="opted_out">
        <h1>Opted-Out.</h1>
      </TranslationProvider>

      <div className="OptOut__body">
        <TranslationProvider translationKey="no_longer_receive_feedback">
          <div className="OptOut__upper-text">
            You’ll no longer receive feedback requests after your reservations.
          </div>
        </TranslationProvider>
        <hr />
        <TranslationProvider translationKey="feedback_is_important">
          <div>
            As a valued guest, your feedback is important to us and helps restaurants continue to improve.
          </div>
        </TranslationProvider>

        <TranslationProvider translationKey="view_communication_preferences">
          <Link href="/account/communication">
            View Communication Preferences ›
          </Link>
        </TranslationProvider>
      </div>
    </div>
  );

  if (notFound) {
    return renderNotFound();
  }

  if (success) {
    return renderSuccess();
  }

  return (
    <div className="OptOut">
      {LoadingIcon}
    </div>
  );
};

const optOutPropTypes = {
  $location: PropTypes.shape({
    search: PropTypes.func.isRequired,
  }).isRequired,
};

OptOut.propTypes = optOutPropTypes;

export { optOutPropTypes };
export default OptOut;
